import { render, staticRenderFns } from "./COE.vue?vue&type=template&id=4ede731b"
import script from "./COE.vue?vue&type=script&lang=js"
export * from "./COE.vue?vue&type=script&lang=js"
import style0 from "./COE.vue?vue&type=style&index=0&id=4ede731b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports